export default __webpack_public_path__ + "static/media/title-1-right.ae41557a.svg";